import React from "react";
import GithubIcon from "../assets/icons/github.svg";
import InstagramIcon from "../assets/icons/instagram.svg";
import GmailIcon from "../assets/icons/gmail.svg";
import { Link } from "react-router-dom";
// import Profile from "../assets/images/profile.png";
export default function Hero(props) {
	return (
		<>
			<div className="md:flex">
				<div className="md:w-4/3">
					<h1 className="text-base text-left sm:text-3xl font-semibold">
						Hi There!, <br /> I'm {props.name} is here
					</h1>
					<p className="font-light mt-5 w-1/2">{props.title}</p>
					<div className="flex items-center">
						<div>
							<button className="bg-secondColors-light text-white px-7 py-2 rounded-lg mt-10 flex">
								<img
									src={GmailIcon}
									style={{ height: "25px", width: "25px" }}
									alt="Gmail Icon"
									className="mx-2"
								/>
								Contact Me
							</button>
						</div>
						<div className="mt-10 mx-5">
							<ul className="flex">
								<li>
									<Link to="/">
										<img
											src={GithubIcon}
											style={{ height: "35px", width: "35px" }}
											alt="Github Icon"
											className="mx-5"
										/>
									</Link>
								</li>
								<li>
									<Link to="/">
										<img
											src={InstagramIcon}
											style={{ height: "35px", width: "35px" }}
											alt="Instagram Icon"
											className="mx-5"
										/>
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="w-2/6">
					<img src="" alt="My Face Is Comming :D" />
				</div>
			</div>
		</>
	);
}
